<template>
<div>
  <layout-panel>
  <el-table :data="table"
            stripe
            highlight-current-row
            border
            style="width: 100%">
    <el-table-column prop="adminid"
                     label="用户ID"
                     min-width="10"></el-table-column>
    <el-table-column prop="adminname"
                     label="用户名"
                     min-width="10"></el-table-column>
    <el-table-column prop="updated_at"
                     label="更新时间"
                     min-width="20"></el-table-column>
    <el-table-column label="更新记录">
      <template slot-scope="scope">
        <el-table :data="visibleChanges(scope.row)"
                  stripe
                  highlight-current-row
                  border
                  style="width: 100%">
          <el-table-column prop="name"
                           label="字段"
                           min-width="20"></el-table-column>
          <el-table-column prop="old"
                           label="修改前"
                           min-width="20">
            <template slot-scope="sonScope">
              <template v-if="isPhotosField(sonScope.row.field)">
                <div v-if="parsePhotoList(sonScope.row.old).length" class="photo-list">
                  <el-image
                    v-for="(url, idx) in parsePhotoList(sonScope.row.old)"
                    :key="'old-' + scope.row.id + '-' + idx"
                    class="photo-thumb"
                    style="width: 64px; height: 64px;"
                    :src="url"
                    :preview-src-list="parsePhotoList(sonScope.row.old)"
                    fit="cover">
                    <div slot="error" class="photo-error">加载失败</div>
                  </el-image>
                </div>
                <span v-else></span>
              </template>
              <span v-else-if="marketOptions.includes(sonScope.row.field)">
                <span v-for="(item, index) in options" v-if="index === sonScope.row.field">
                    <span v-for="val in item" v-if="val.value === sonScope.row.old">
                       {{val.label}}
                    </span>
                  </span>
               </span>
              <span v-else>
                {{sonScope.row.old}}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="new"
                           label="修改后"
                           min-width="20">
            <template slot-scope="sonScope">
              <template v-if="isPhotosField(sonScope.row.field)">
                <div v-if="parsePhotoList(sonScope.row.new).length" class="photo-list">
                  <el-image
                    v-for="(url, idx) in parsePhotoList(sonScope.row.new)"
                    :key="'new-' + scope.row.id + '-' + idx"
                    class="photo-thumb"
                    style="width: 64px; height: 64px;"
                    :src="url"
                    :preview-src-list="parsePhotoList(sonScope.row.new)"
                    fit="cover">
                    <div slot="error" class="photo-error">加载失败</div>
                  </el-image>
                </div>
                <span v-else></span>
              </template>
              <span v-else-if="marketOptions.includes(sonScope.row.field)">
                <span v-for="(item, index) in options" v-if="index === sonScope.row.field">
                    <span v-for="val in item" v-if="val.value === sonScope.row.new">
                       {{val.label}}
                    </span>
                  </span>
               </span>
              <span v-else>
                {{sonScope.row.new}}
              </span>
            </template>
          </el-table-column>
        </el-table>
        <div
          v-if="scope.row.changes && scope.row.changes.length > 3"
          class="changes-toggle">
          <el-button type="text" @click="toggleExpand(scope.row)">
            {{ isExpanded(scope.row) ? '折叠全部字段' : '展开全部字段' }}
          </el-button>
        </div>
      </template>
    </el-table-column>
  </el-table>
  <div class="pagination">
    <el-pagination background
                   @size-change="handleSizePageChange"
                   @current-change="handleCurrentPageChange"
                   :current-page="pagination.current_page"
                   :page-sizes="[20, 50, 100, 200]"
                   :page-size="pagination.per_page"
                   layout="total, sizes, prev, pager, next, jumper"
                   :total="pagination.total">
    </el-pagination>
  </div>
  </layout-panel>
</div>
</template>

<script>
import table from '@core/mixins/table'
import marketMixins from '../market.mixins'
export default {
  name: 'MarketLogTable',
  mixins: [table, marketMixins],
  data () {
    return {
      table: [],
      search: {
        id: null,
      },
      marketOptions: ['market_size', 'markettype', 'isee', 'is_chain', 'gatherinfo_status', 'status'],
      expandedLogIds: {}
    }
  },
  computed: {
    ...Vuex.mapState({
      options: state => state.market.options,
    }),
  },
  methods: {
    ...Vuex.mapActions([]),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData () {
      return request.common('queryMarketLog', {id: this.$route.params.id})
    },
    isPhotosField (field) {
      return field === 'photos'
    },
    parsePhotoList (val) {
      if (!val && val !== 0) {
        return []
      }
      if (Array.isArray(val)) {
        return val.map(item => {
          if (typeof item === 'string') {
            return item
          }
          if (item && typeof item === 'object') {
            return item.url || item.src || item.path || ''
          }
          return ''
        }).filter(Boolean)
      }
      if (typeof val === 'string') {
        const trimmed = val.trim()
        if (!trimmed) {
          return []
        }
        if (trimmed.charAt(0) === '[' || trimmed.charAt(0) === '{') {
          try {
            return this.parsePhotoList(JSON.parse(trimmed))
          } catch (e) {
            return []
          }
        }
        if (trimmed.indexOf('http') === 0) {
          return [trimmed]
        }
      }
      return []
    },
    isExpanded (row) {
      return !!this.expandedLogIds[row.id]
    },
    toggleExpand (row) {
      this.$set(this.expandedLogIds, row.id, !this.expandedLogIds[row.id])
    },
    visibleChanges (row) {
      const changes = row.changes || []
      // 店招优先展示，避免折叠时被挤到第 3 行之后看不到
      const photos = changes.filter(item => this.isPhotosField(item.field))
      const rest = changes.filter(item => !this.isPhotosField(item.field))
      const ordered = photos.concat(rest)
      if (ordered.length <= 3 || this.isExpanded(row)) {
        return ordered
      }
      return ordered.slice(0, 3)
    }
  }
}
</script>

<style scoped>
.changes-toggle {
  text-align: center;
  padding-top: 6px;
}
.photo-list {
  display: flex;
  flex-wrap: wrap;
}
.photo-thumb {
  width: 64px;
  height: 64px;
  margin-right: 6px;
  margin-bottom: 6px;
  border-radius: 2px;
  cursor: pointer;
  overflow: hidden;
  background: #f5f7fa;
}
.photo-error {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #909399;
  background: #f5f7fa;
}
</style>



// WEBPACK FOOTER //
// src/views/market/pages/MarketLogTable.vue